<template>
  <v-dialog
    v-model="value"
    max-width="500px"
  >
    <v-card>
      <BarTitleDialog
        title="Cartão de Débito"
        @close="$emit('input', false)"
      />

      <v-card-text>
        <v-row>
          <v-col class="text-left text">
            Valor a pagar
          </v-col>
          <v-col class="text-right text">
            R$ {{ formatMoney(remainingValueSeparate) }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field
              v-model="codeOperation"
              class="mt-5"
              outlined
              label="Código de Autorização"
              required
              :error-messages="codeOperationError"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- <v-row >
              <v-col>
                <v-select hide-details outlined v-model="selectNumberInstallment"   label="Parcelas" :items="numberInstallment"></v-select>
              </v-col>
            </v-row> -->
        <v-row no-gutters>
          <v-col>
            <vuetify-money
              v-model="payValue"
              :error-messages="validPayValue"
              outlined
              label="Valor pago pelo cliente"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col class="text-right">
            <v-btn
              text
              x-large
              @click="close()"
            >
              Cancelar
            </v-btn>
            <v-btn
              class="ml-2"
              color="primary"
              x-large
              @click="addPayment()"
            >
              Receber
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mdiWindowClose,
} from '@mdi/js'
import {
  mapGetters,
  mapMutations,
} from 'vuex'

import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {
  components: {
    BarTitleDialog,
  },
  props: {
    value: {
      type: Boolean,
    },
  },
  data: () => ({
    codeOperation: '',
    codeOperationError: [],
    valueValid: [],
    payValue: 0,
    icons: {
      mdiWindowClose,
    },
  }),
  watch: {
    value(val) {
      if (val) {
        // this.generateValues()
        this.payValue = this.remainingValueSeparate
      }
    },

    codeOperation() {
      this.codeOperationError = []
    },

  },

  created() {

  },
  computed: {
    ...mapGetters('checkout', ['remainingValueSeparate']),
    validPayValue() {
      if (this.payValue <= 0) {
        return this.valueValid = ['Quantia deve ser 0.01 ou superior']
      }

      return []
    },

  },
  methods: {
    ...mapMutations('checkout', ['addPaymentMethodSeparate']),
    close() {
      this.$emit('input', false)
    },

    addPayment() {
      if (!this.codeOperation) {
        this.codeOperationError = ['Código de Autorização é obrigatório']

        return false
      }
      if (this.payValue <= 0) {
        this.valueValid = 'Quantia deve ser 0.01 ou superior'

        return false
      }
      const paymentMethod = {
        method: 'debit_card',
        value: this.payValue,
        code_operation: this.codeOperation,
      }

      this.addPaymentMethodSeparate(paymentMethod)
      this.close()

      // if (this.remainingValue > 0) { // se existe valor restante vai para a pagina de mutiplas formas de pagamento
      //     this.setStage('multiple_payment_methods')
      // }
    },
    formatMoney(value) {
      if (value != null) {
        return value.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
    },
  },

}
</script>

<style scoped>
.text {
    color: black;
    font-size: large;
}

.card {
    height: 67px;
    cursor: pointer;
    border: solid 1px black;
}

.change {
    color: blueviolet;
    font-size: medium;
}

.card:hover {
    background: rgb(248, 248, 248);
}
</style>
